module.exports = __webpack_public_path__ + "img/play.dd02bfe4.png";